<!-- page wrapper -->
<button mat-button class="toolbar-icon-button dialog-closeicon"  (click)="onCancel()">
    <mat-icon class="material-icons dialog-closeicon">
        close
    </mat-icon>
</button>
<div theme class="session-expired-container">
    <div fxLayout="column" fxLayoutAlign="center center">
        <!-- icon -->
        <mdb-icon fas icon="ban" size="3x" class="mb-3 animated rotateIn dialog-animated-error-icon">
        </mdb-icon>
        <!-- violation content -->
        <p class="error-title-text" cdkFocusInitial>{{errorTitle}}</p> <!-- Upload Denied -->
        <p class="error-message-text">{{errorMessage}}</p><!-- Uploaded file type is not permitted (or) Uploaded file size exceeds 2 mb -->
        <p class="retry-text" *ngIf="errorTitle === 'Upload Denied'">Retry with a valid file</p>
    </div>
</div>
